import React from "react";

import EmailVerificationInfo from "./EmailVerificationInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import ListBody from "./ListBody";
import { defineMessages, FormattedMessage } from "react-intl";
import DeleteResourceButton from "./DeleteResourceButton";
import { Table, TableCell, TableHead, TableRow } from "@mui/material";

const translations = defineMessages({
    address: {
        id: "user_email.address",
        defaultMessage: "Address",
    },
    verified: {
        id: "user_email.verified",
        defaultMessage: "Verified",
    },
    disabled_of_one: {
        id: "user_email.disabled_of_one",
        defaultMessage: "Delete is disabled because you must have at least one verified email address",
    },
});

type UserEmailsTableProps = {
    rows: any[];
};

const UserEmailsTable: React.FC<UserEmailsTableProps> = ({ rows }) => {
    const verifiedIds = rows.filter((row) => row.verified_at != null).map((row) => row.id);
    const deleteDisabled = verifiedIds.length == 1 ? verifiedIds[0] : 0;

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>
                        <FormattedMessage {...translations.address} />
                    </TableCell>
                    <TableCell>
                        <FormattedMessage {...translations.verified} />
                    </TableCell>
                    <TableCell />
                    <TableCell />
                </TableRow>
            </TableHead>
            <ListBody
                data={rows}
                header={["address", "verified_at", "verificationInfo", "controls"]}
                renderers={{
                    verified_at: (val) => {
                        const icon =
                            val != null ? (
                                <FontAwesomeIcon icon={faCheck} color="green" />
                            ) : (
                                <FontAwesomeIcon icon={faTimes} color="red" />
                            );
                        return <div style={{ textAlign: "center" }}>{icon}</div>;
                    },
                    verificationInfo: (val, data) => {
                        if (data.verified_at == null) return <EmailVerificationInfo data={data} />;
                        return null;
                    },
                    controls: (val, data) => {
                        const disabled = data.id == deleteDisabled;
                        return (
                            <DeleteResourceButton
                                resourceName="user_email"
                                tooltip={disabled ? <FormattedMessage {...translations.disabled_of_one} /> : null}
                                disabled={disabled}
                                id={data.id}
                            />
                        );
                    },
                }}
            />
        </Table>
    );
};

export default UserEmailsTable;
